const ranksConfig = [
  {
    rank: "bronze",
    name: "برنزی",
    tax: "۰.۴",
    period: "۲۰ میلیون",
  },
  {
    rank: "silver",
    name: "نقره‌ای",
    tax: "۰.۳",
    period: "۲۰ - ۵۰ میلیون",
  },
  {
    rank: "golden",
    name: "طلایی",
    tax: "۰.۲",
    period: "۵۰ - ۱۰۰ میلیون",
  },
  {
    rank: "diamond",
    name: "الماس",
    tax: "۰.۱۵",
    period: "بیش از ۱۰۰ میلیون",
  },
];

export default ranksConfig;
